function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 22 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "11",
  cy: "11.929",
  r: "11",
  transform: "rotate(90 11 11.929)",
  fill: "rgba(55, 53, 47, 0.45)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.526 9.616l2.582 2.562a.52.52 0 00.731-.737L11.704 8.33a1 1 0 00-1.41 0L7.16 11.44a.52.52 0 00.731.737l2.582-2.562v6.787a.526.526 0 001.053 0V9.616z",
  fill: "#fff"
})));